import { render, staticRenderFns } from "./BaseDeliveryPointConfirmDialog.vue?vue&type=template&id=38141e5c"
import script from "./BaseDeliveryPointConfirmDialog.vue?vue&type=script&lang=js"
export * from "./BaseDeliveryPointConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports